import React from "react";
import Navbar from "../../components/navbar/Navbar";
import "../../assets/css/style.css";
import "../../assets/css/style.css.map";
import "../../assets/scss/layout/_navbar.scss";
import Footer from "../../components/footer/Footer";

const Layout = (props) => {
  return (
    <>
      <Navbar />
      <main>{props.children}</main>
      <Footer />
    </>
  );
};

export default Layout;
